<div class="dropzone" appDragAndDrop (fileDropped)="onFileDropped($event)">
  <input
    type="file"
    #fileDropRef
    id="fileDropRef"
    multiple
    (change)="($event.target.files)"
  />
  <img src="" alt="" />
  <h3>Drag and drop files here</h3>
  <h3>or</h3>
  <label for="fileDropRef">Browse for file</label>
</div>
<div class="filesList">
  <div class="singleFile" *ngFor="let file of files; let i = index">
    <img src="" width="45px" alt="file" />
    <div class="info">
      <h4 class="name">
        {{ file?.name }}
      </h4>
      <p class="size">
        {{ file?.size }}
      </p>
      <!-- <mat-progress-bar value="file?"></mat-progress-bar> -->
    </div>
  </div>
</div>
